import React from "react";
import classnames from "classnames";
export function DonationButton({ amt, donationAmt, isMonthly, setDonationAmt, getOneTimeDonationAmt, getAnnualDonationAmt}) {

  return (
    <div className="control is-flex-grow-1">
      <button
        className={classnames("button has-text-weight-semibold is-fullwidth", amt === donationAmt ? "has-text-white": "has-background-info-light")}
        onClick={() => {
          setDonationAmt(amt);
        }}
        style={amt === donationAmt ? {backgroundColor:'#8C52FF'} : {}}
      >
        {isMonthly ===1 ? `$${getAnnualDonationAmt(amt)}/yr` : isMonthly===2 ? `$${amt}/mo` : `$${getOneTimeDonationAmt(amt)}`}
      </button>
    </div>
  );
}

export function DonationButtonsMobile ({monthlyDonationAmts, donationAmt, setDonationAmt, isMonthly, getOneTimeDonationAmt, getAnnualDonationAmt}) {

  return (
    <div>
      <div className="field is-grouped is-mobile is-align-content-center is-justify-content-center mx-6">
        {monthlyDonationAmts
        
        .slice(0, 2).map((amt, i) => (
          <DonationButton key={i} amt={amt} donationAmt={donationAmt} isMonthly={isMonthly} setDonationAmt={setDonationAmt} getOneTimeDonationAmt={getOneTimeDonationAmt} getAnnualDonationAmt={getAnnualDonationAmt}/>
        ))}
      </div>

      <div className="field is-grouped is-mobile is-align-content-center is-justify-content-center mx-6">
        {monthlyDonationAmts.slice(2, 4).map((amt, i) => (
          <DonationButton key={i} amt={amt} donationAmt={donationAmt} isMonthly={isMonthly} setDonationAmt={setDonationAmt} getOneTimeDonationAmt={getOneTimeDonationAmt} getAnnualDonationAmt={getAnnualDonationAmt}/>
        ))}
      </div>
    </div>
  );
}

export function DonationButtonsNotMobile ({monthlyDonationAmts, donationAmt, setDonationAmt, isMonthly, getOneTimeDonationAmt, getAnnualDonationAmt}) {

    return (
        <div>
            <div className="field is-grouped is-mobile is-align-content-center is-justify-content-center mx-6">
                {monthlyDonationAmts
                
                .map((amt, i) => (
                    <DonationButton key={i} amt={amt} donationAmt={donationAmt} isMonthly={isMonthly} setDonationAmt={setDonationAmt} getOneTimeDonationAmt={getOneTimeDonationAmt} getAnnualDonationAmt={getAnnualDonationAmt}/>
                ))}
            </div>
        </div>
    );
  }